var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useCard)?_c('vx-card',{staticStyle:{"width":"calc(100% - 40px)"}},[_c(_vm.component,{tag:"component"})],1):_c('div',[_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }